var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { "margin-top": "100px" },
      attrs: { id: "new-waba-channel-form" },
    },
    [
      _c("a-form", [
        _c(
          "div",
          { staticClass: "form-wrapper" },
          [
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("whatsappChannel.channelName"))),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t("whatsappChannel.channelName"),
                    name: "channelName",
                  },
                  model: {
                    value: _vm.clone.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "name", $$v)
                    },
                    expression: "clone.name",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [
                  _vm._v(
                    _vm._s(_vm.$t("whatsapp_business_api.phoneNumberE164"))
                  ),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t(
                      "whatsapp_business_api.phoneNumberE164Place"
                    ),
                    name: "phoneNumber",
                  },
                  model: {
                    value: _vm.clone.payload.phoneNumber,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone.payload, "phoneNumber", $$v)
                    },
                    expression: "clone.payload.phoneNumber",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c(
                  "div",
                  { staticClass: "mt-1 mb-1" },
                  [
                    _c("a-switch", {
                      attrs: { checked: !!_vm.clone.forward.stroy },
                      on: { click: _vm.toggleChatbot },
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "👉 " +
                          _vm._s(_vm.$t("whatsappChannel.forwardToChatbot"))
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-1 mb-1" },
                  [
                    _c("a-switch", {
                      model: {
                        value: _vm.clone.enabled,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone, "enabled", $$v)
                        },
                        expression: "clone.enabled",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.clone.enabled
                            ? _vm.$t("whatsapp.channelSwitchOnEmoji")
                            : _vm.$t("whatsapp.channelSwitchOffEmoji")
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("whatsappChannel.forwardingChatbotOrLiveAgent")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    attrs: {
                      defaultValue: null,
                      notFoundContent: _vm.$t(
                        "whatsapp.notFoundContentForwardLiveAgents"
                      ),
                      disabled: !_vm.showStories,
                    },
                    on: { change: _vm.handleStoryChange },
                    model: {
                      value: _vm.clone.forward.stroy,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone.forward, "stroy", $$v)
                      },
                      expression: "clone.forward.stroy",
                    },
                  },
                  [
                    !_vm.checkHaveChatbotStroy(_vm.clone.forward.stroy)
                      ? _c(
                          "a-select-option",
                          { attrs: { selected: true, value: null } },
                          [
                            _vm._v(
                              "\n                        👉 " +
                                _vm._s(_vm.$t("whatsapp.forwardLiveAgents")) +
                                "\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.stories, function (story) {
                      return _c(
                        "a-select-option",
                        { key: story._id, attrs: { value: story._id } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(story.title) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("whatsapp.departmentForwarding"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    attrs: { defaultValue: null },
                    on: { change: _vm.getSubjectTitle },
                    model: {
                      value: _vm.clone.forward.department,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone.forward, "department", $$v)
                      },
                      expression: "clone.forward.department",
                    },
                  },
                  [
                    _c(
                      "a-select-option",
                      { attrs: { selected: true, value: null } },
                      [
                        _vm._v(
                          "👉" + _vm._s(_vm.$t("whatsapp.selectedDepartment"))
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.subjects, function (department) {
                      return _c(
                        "a-select-option",
                        {
                          key: department._id,
                          attrs: { value: department._id },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.getSubjectTitle(department)) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("VisibilityChanger", {
              model: {
                value: _vm.clone.visibility,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "visibility", $$v)
                },
                expression: "clone.visibility",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c("div", { staticClass: "actions" }, [
          _c(
            "button",
            {
              staticClass: "pr-confirm-btn save-btn",
              attrs: { type: "primary", disabled: _vm.loading },
              on: { click: _vm.updateChannelData },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("billing.save")) +
                  "\n            "
              ),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }